var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-avatar",class:{ border: _vm.hasBorder },style:(_vm.wrapperStyle)},[_c('img',{directives:[{name:"src",rawName:"v-src",value:(_vm.image),expression:"image"}],style:(_vm.imageStyle),on:{"error":function($event){return _vm.$emit('image-error')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }